import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Checkout from "./Checkout";
import StartUser from "../Containers/StartUser";

// import Pricing from "../Containers/Ordenar";

function TabPanel(props) {
  const { children, value, index } = props;

  return value === index && <Box sx={{ p: 3 }}>{children}</Box>;
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function PaintConteiner({ value, ...pros }) {
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}></Box>
      <TabPanel value={value} index={0} title="Dashboard">
        <Checkout/>
      {/* <Addproduct data={pros.data} id={pros.id}/> */}
      </TabPanel>

      <TabPanel value={value} index={1}>
        <StartUser  />
      </TabPanel>


    </Box>
  );
}
